import React, { useEffect, useState } from 'react';
import { Button, Card } from '../../shared/components';
import { api } from '../../utils/api';
import './Flashcards.css';

export default function FlashcardViewer({ topic, onExit }) {
  const [cards, setCards] = useState([]);
  const [index, setIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get(`/api/flashcards/${topic.slug}`)
      .then((data) => {
        setCards(data);
        setLoading(false);
      })
      .catch(() => {
        setError('Unable to load flashcards right now.');
        setLoading(false);
      });
  }, [topic.slug]);

  async function markStatus(status) {
    const card = cards[index];
    try {
      await api.post(`/api/flashcards/${card.id}/review`, { status });
    } catch (err) {
      setError('Unable to save your progress right now.');
    }
    goNext();
  }

  function goNext() {
    setFlipped(false);
    setIndex((prev) => Math.min(prev + 1, cards.length - 1));
  }

  function goPrev() {
    setFlipped(false);
    setIndex((prev) => Math.max(prev - 1, 0));
  }

  if (loading) return <p>Loading flashcards&hellip;</p>;
  if (error) return <p className="flashcards-error">{error}</p>;
  if (cards.length === 0) return <p>No flashcards available for this topic yet.</p>;

  const card = cards[index];

  return (
    <div className="flashcards-page">
      <h1>{topic.name}</h1>
      <p className="flashcards-progress">
        Card {index + 1} of {cards.length}
      </p>

      <Card className={`flashcard ${flipped ? 'flashcard--flipped' : ''}`} onClick={() => setFlipped((f) => !f)}>
        <p className="flashcard-content">{flipped ? card.definition : card.term}</p>
        <p className="flashcard-hint">{flipped ? 'Definition' : 'Term — tap to flip'}</p>
      </Card>

      <div className="flashcards-actions">
        <Button variant="secondary" onClick={goPrev} disabled={index === 0}>Previous</Button>
        <Button variant="danger" onClick={() => markStatus('review')}>Needs review</Button>
        <Button onClick={() => markStatus('known')}>I know this</Button>
      </div>

      <button className="flashcards-exit" onClick={onExit}>Back to topics</button>
    </div>
  );
}
